import React from "react"
import { Row, Col } from "antd"
import styles from "./KategoriProgram.module.css"
import CardProgram from "./components/CardProgram"
import Inhouse from "./images/in-house-training.png"
import Konsul from "./images/konsultasi.png"
import Campus from "./images/campus-partner.png"
import ButtonGreenOriginal from "../../../../components/ButtonGreen/Original"

const KategoriProgram = ({onInfoClick}) => {
  return (
    <>
      <div className={`container ${styles.KategoriProgram}`} data-aos="fade-up">
        <Row gutter={[24, 0]} justify="center" className={styles.program}>
          <Col span={8} className={styles.desc}>
            <h1 className={styles.tittle}>Program Partnership Unggulan</h1>
            <div className={styles.textnbtn}>
              <p className={styles.text}>
                Rangkaian program yang berkembang dari kebutuhan nyata industri
                dan akademisi untuk memperkuat kapabilitas tim, mempermudah
                proses sertifikasi, serta membuka peluang kolaborasi lintas
                sektor dan perguruan tinggi
              </p>
              <div className={styles.btnKonsulTop}>
                <ButtonGreenOriginal
                  namaBtn="Konsultasi GRATIS Sekarang!"
                  onClick={onInfoClick}
                  custom={{ fontSize: "16px" }}
                />
              </div>
            </div>
          </Col>

          <Col span={5}>
            <CardProgram
              image={Inhouse}
              title="In-house Training"
              desc="Meningkatkan kompetensi dan kinerja tim sesuai kebutuhan
              perusahaan"
            />
          </Col>

          <Col span={5}>
            <CardProgram
              image={Konsul}
              title="Konsultasi dan Pendampingan Sertifikasi"
              desc="Bimbingan pakar standar sertifikasi (ISO, Halal, HACCP)"
            />
          </Col>

          <Col span={5}>
            <CardProgram
              image={Campus}
              title="Campus Partner"
              desc="Kolaborasi strategis dengan kampus untuk mencetak talenta pangan berkualitas."
            />
          </Col>
        </Row>
        <Row justify="center" className={styles.btnKonsulBottom}>
          <Col span={7}></Col>
          <Col span={10}>
            <ButtonGreenOriginal
              namaBtn="Konsultasi GRATIS Sekarang!"
              onClick={onInfoClick}
            />
          </Col>
          <Col span={7}></Col>
        </Row>
      </div>
    </>
  )
}

export default KategoriProgram
